import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  run_hdr_guid: fromDatatype.GuidDataFieldInterface;
  from_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
  from_irb_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowClass
  implements bl_fi_my_einvoice_from_irb_match_gen_doc_queue_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    run_hdr_guid: fromDatatype.GuidDataFieldInterface;
    from_irb_hdr_guid: fromDatatype.GuidDataFieldInterface;
    from_irb_hdr_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
